import React from 'react';
import styled from 'styled-components';

import { ReactComponent as ClipShareIcon } from '../../../../assets/clip-share.svg';
import { ReactComponent as BlueCheckIcon } from '../../../../assets/blue-check.svg';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { FirebaseEvents } from '../../../../utils/enums/firebase-events';
import { Specialist } from '../../../../models/Specialist';

export const CopyLink = styled.a`
  color: #0376a3;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 12px;
  cursor: pointer;
`;

export type ClipboardButtonProps = {
  selectedSpecialist: Specialist;
};

export const ClipboardButton = ({ selectedSpecialist }: ClipboardButtonProps) => {
  const [copied, setCopied] = React.useState(false);
  const { logEvent } = useAnalytics();

  function copyToClipboard(text: string): void {
    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = text;

    document.body.appendChild(tempTextArea);

    tempTextArea.select();

    document.execCommand('copy');

    document.body.removeChild(tempTextArea);

    setCopied(true);
  }

  function handleLinkWithSpecialistName() {
    const specialistNameReplaced = selectedSpecialist.name.replaceAll(' ', '-');
    return `${window.location.origin}/?medicos_einstein=${specialistNameReplaced}`;
  }

  return (
    <CopyLink
      onClick={() => {
        logEvent({
          eventName: FirebaseEvents.schedule_copy_specialist_url,
          eventParams: {
            specialist_id: selectedSpecialist?.id ?? '',
            specialist_name: selectedSpecialist?.name ?? '',
            specialist_url: handleLinkWithSpecialistName()
          }
        });

        copyToClipboard(handleLinkWithSpecialistName());
      }}
    >
      {copied ? <BlueCheckIcon /> : <ClipShareIcon />}
      {copied ? 'Link copiado com sucesso!' : 'Copiar link do perfil médico'}
    </CopyLink>
  );
};
